import { memo } from 'react';

/** One entry of an Activity tab, as drawn: its heading, the field changes it lists, and its date-and-performer line. */
export interface ActivityEntryView {
  key: string;
  label: string;
  changes: readonly { field: string; from: string; to: string }[];
  /** The line under the entry: when, and by whom, worded by the caller. */
  meta: string;
}

/**
 * An Activity tab's list (`ms-activity`, masterScreen.css), latest entry first as given.
 *
 * Shared by the masters' Activity tab and the templates' View dialog (ui-refactor-shared-ui), which used to draw the
 * same markup each in its own copy. Loading, empty and failed states stay with each caller, which words them.
 */
export const ActivityEntries = memo(function ActivityEntries({ entries }: { entries: readonly ActivityEntryView[] }) {
  return (
    <ol className="ms-activity">
      {entries.map((entry) => (
        <li key={entry.key} className="ms-activity__item">
          <span className="ms-activity__dot" aria-hidden="true" />
          <div className="ms-activity__body">
            <span className="ms-activity__label">{entry.label}</span>
            {entry.changes.length > 0 ? (
              <ul className="ms-activity__changes">
                {entry.changes.map((change, index) => (
                  <li key={`${change.field}-${String(index)}`} className="ms-activity__change">
                    <span className="ms-activity__field">{change.field}:</span> {change.from} → {change.to}
                  </li>
                ))}
              </ul>
            ) : null}
            <span className="ms-activity__meta">{entry.meta}</span>
          </div>
        </li>
      ))}
    </ol>
  );
});
